var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "un-scheduled-list"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitflt.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true, 'error': _vm.errors.has('FromDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "FromDate"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('FromDate')),
      expression: "errors.has('FromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('FromDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true, 'error': _vm.errors.has('ToDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "ToDate",
      "not-before": _vm.fromdate
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ToDate')),
      expression: "errors.has('ToDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ToDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.vehiclenolist,
      "selected-option": _vm.vehiclenoitem,
      "name": "VehicleNo",
      "placeholder": "Select Vehicle No"
    },
    on: {
      "select": _vm.selectedVehicleNo
    },
    model: {
      value: (_vm.vehicleno),
      callback: function($$v) {
        _vm.vehicleno = $$v
      },
      expression: "vehicleno"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.vehiclenoLoading))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vendor Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.vendornamelist,
      "selected-option": _vm.vendornameitem,
      "name": "VendorName",
      "placeholder": "Select Vendor Name"
    },
    on: {
      "select": _vm.selectedVendor
    },
    model: {
      value: (_vm.vendorname),
      callback: function($$v) {
        _vm.vendorname = $$v
      },
      expression: "vendorname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.vendornameLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "-1.2rem"
    }
  }, [_c('b-form-fieldset', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-top": "9%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "common-secondary",
    staticStyle: {
      "margin-top": "9%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetflt
    }
  }, [_vm._v("Reset")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "common-success-btn",
    staticStyle: {
      "margin-top": "9%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openLocalTripModal
    }
  }, [_vm._v("Schedule Local Trip")])])], 1)])])]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Driver Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Mobile No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsRoundTrip")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Schedule Trip")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Replace Vehicle")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.unschedulesList), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shortconnectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehicleno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehiclename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.drivername))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.driverphone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.IsRoundTrip))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-truck fa-2x",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "title": "Schedule Trip"
      },
      on: {
        "click": function($event) {
          return _vm.showMdl(data)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-warning-btn-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showReplaceVehicle(data)
        }
      }
    }, [_vm._v("Replace Vehicle")])])])
  }), _vm._v(" "), (_vm.unschedulesList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)], 1)])]), _vm._v(" "), (_vm.showModal == true) ? _c('b-modal', {
    attrs: {
      "size": "sm",
      "title": "Schedule Trip"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Schedule Trip")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.schduleLoading
    },
    on: {
      "update:active": function($event) {
        _vm.schduleLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('span', [_vm._v("Do you want to schedule a trip ? ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.scheduleVehicle
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("No")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Replace Vehicle"
    },
    model: {
      value: (_vm.showReplaceVehicleModal),
      callback: function($$v) {
        _vm.showReplaceVehicleModal = $$v
      },
      expression: "showReplaceVehicleModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Replace Vehicle")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeReplaceVehicleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Old Vehicle Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-truck'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldVehicleNo),
      expression: "oldVehicleNo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Old Vehicle No",
      "name": "oldVehicleNo",
      "id": "oldVehicleNo",
      "disabled": true
    },
    domProps: {
      "value": (_vm.oldVehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldVehicleNo = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('vehicleNumber')
    },
    attrs: {
      "name": "vehicleNumber",
      "id": "vehicleNumber",
      "options": _vm.vehcileListArr,
      "selected-option": _vm.vehicleitem,
      "placeholder": "Select Vehicle"
    },
    on: {
      "select": _vm.SelectVehicle
    },
    model: {
      value: (_vm.vehicleNumber),
      callback: function($$v) {
        _vm.vehicleNumber = $$v
      },
      expression: "vehicleNumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.showvehicleNumberErr))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.vehicleLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Replacement Reasons")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replacementReason),
      expression: "replacementReason"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('replacementReason')
    },
    attrs: {
      "name": "replacementReason",
      "id": "replacementReason"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.replacementReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checkErr]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _vm._l((_vm.reasonListArr), function(data) {
    return _c('option', {
      domProps: {
        "value": data.Reason
      }
    }, [_vm._v(_vm._s(data.Reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.showreplacementReasonErr))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.replaceVehicle
    }
  }, [_vm._v("Replace")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-danger pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeReplaceVehicleModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "#confirmationmodal",
      "title": "schedule Local Trip Modal",
      "no-close-on-backdrop": true,
      "no-close-on-esc": true
    },
    model: {
      value: (_vm.LocalTripModal),
      callback: function($$v) {
        _vm.LocalTripModal = $$v
      },
      expression: "LocalTripModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Generate Local/Linehaul Biker Trip Sheet")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeLocalTripModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6 radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip),
      expression: "trip"
    }],
    attrs: {
      "type": "radio",
      "id": "networklocal",
      "value": "networklocal"
    },
    domProps: {
      "checked": _vm._q(_vm.trip, "networklocal")
    },
    on: {
      "change": [function($event) {
        _vm.trip = "networklocal"
      }, function($event) {
        return _vm.getConnections(4)
      }],
      "click": _vm.ResetBikerTripDetails
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "networklocal"
    }
  }, [_vm._v("Local-TP Trip")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip),
      expression: "trip"
    }],
    attrs: {
      "type": "radio",
      "id": "linehaulbiker",
      "value": "linehaulbiker"
    },
    domProps: {
      "checked": _vm._q(_vm.trip, "linehaulbiker")
    },
    on: {
      "change": [function($event) {
        _vm.trip = "linehaulbiker"
      }, function($event) {
        return _vm.getConnections(6)
      }],
      "click": _vm.ResetLocalTripDetails
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "linehaulbiker"
    }
  }, [_vm._v("Linehaul-Biker Trip")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.tripErr))])]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.trip == 'networklocal'),
      expression: "trip=='networklocal'"
    }],
    attrs: {
      "name": "localtripTab"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitLocalTrip('localtripTab')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    class: {
      'error': _vm.errors.has('localtripTab.TripSheetNoDate')
    },
    attrs: {
      "disabled": "",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "TripSheetNoDate",
      "data-vv-scope": "localtripTab"
    },
    model: {
      value: (_vm.tripsheetnodate),
      callback: function($$v) {
        _vm.tripsheetnodate = $$v
      },
      expression: "tripsheetnodate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.TripSheetNoDate')),
      expression: "errors.has('localtripTab.TripSheetNoDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.TripSheetNoDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.Route')
    },
    attrs: {
      "options": _vm.routelist,
      "selected-option": _vm.routeitem,
      "name": "Route",
      "placeholder": "Select Route",
      "id": "Route",
      "data-vv-scope": "localtripTab"
    },
    on: {
      "select": _vm.selectRoute
    },
    model: {
      value: (_vm.route),
      callback: function($$v) {
        _vm.route = $$v
      },
      expression: "route"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.RouteError))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.Route')),
      expression: "errors.has('localtripTab.Route')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.Route')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.RouteLoading))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#1985ac",
      "font-weight": "bold",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.actualroute))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.isBikerFlag) ? _c('div', {
    staticClass: "col-md-6 checkbox"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bikertrip),
      expression: "bikertrip"
    }],
    attrs: {
      "type": "checkbox",
      "id": "bikertrip",
      "value": "bikertrip"
    },
    domProps: {
      "checked": Array.isArray(_vm.bikertrip) ? _vm._i(_vm.bikertrip, "bikertrip") > -1 : (_vm.bikertrip)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.bikertrip,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "bikertrip",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.bikertrip = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.bikertrip = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.bikertrip = $$c
        }
      }, function($event) {
        return _vm.enabledBikerCondtion()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "bikertrip"
    }
  }, [_vm._v("Biker Trip")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.isBikerTripEnabled) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("SR Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('localtripTab.SR')
    },
    attrs: {
      "options": _vm.srListForAllocatedParentCity,
      "name": "SR",
      "label": "text",
      "track-by": "value",
      "placeholder": "Select SR ",
      "show-labels": false,
      "multiple": false,
      "max-height": 300,
      "clearable": false,
      "data-vv-scope": "localtripTab"
    },
    on: {
      "select": _vm.selectSr
    },
    model: {
      value: (_vm.sr),
      callback: function($$v) {
        _vm.sr = $$v
      },
      expression: "sr"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.SR')),
      expression: "errors.has('localtripTab.SR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.SR')))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isBikerTripEnabled) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Trip Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.TripType')
    },
    attrs: {
      "options": _vm.triptypelist,
      "selected-option": _vm.triptypeitem,
      "name": "TripType",
      "placeholder": "Select TripType",
      "id": "TripType",
      "data-vv-scope": "localtripTab"
    },
    on: {
      "select": _vm.selectTripType
    },
    model: {
      value: (_vm.triptype),
      callback: function($$v) {
        _vm.triptype = $$v
      },
      expression: "triptype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.TripType')),
      expression: "errors.has('localtripTab.TripType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.TripType')))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.triptypeitem.value || (!_vm.isBikerTripEnabled && (_vm.triptypeitem.value == 'local' || (_vm.triptypeitem.value == 'market' && !_vm.isAdhocEnable)))) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vendor")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.Vendor')
    },
    attrs: {
      "options": _vm.localvendorlist,
      "selected-option": _vm.localvendoritem,
      "name": "Vendor",
      "placeholder": "Select Vendor",
      "id": "Vendor",
      "data-vv-scope": "localtripTab",
      "selected": _vm.localvendoritem.text
    },
    on: {
      "select": _vm.selectVendor
    },
    model: {
      value: (_vm.localvendor),
      callback: function($$v) {
        _vm.localvendor = $$v
      },
      expression: "localvendor"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.Vendor')),
      expression: "errors.has('localtripTab.Vendor')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.Vendor')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.LocalVendorLoading))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.triptypeitem.value && (_vm.triptypeitem.value == 'market' || (!_vm.isBikerTripEnabled && (_vm.triptypeitem.value != 'local')))) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vendor Name")]), (_vm.isAdhocEnable) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-car'></i>"
    }
  }, [(_vm.triptypeitem.value == 'market' && _vm.isAdhocEnable) ? _c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.adhocvendor')
    },
    attrs: {
      "options": _vm.adhocvendorlist,
      "selected-option": _vm.adhocvendoritem,
      "name": "adhocvendor",
      "placeholder": "Select Vendor",
      "id": "adhocvendor",
      "data-vv-scope": "localtripTab",
      "selected": _vm.adhocvendoritem.text
    },
    on: {
      "select": _vm.selectAdhocVendor
    },
    model: {
      value: (_vm.adhocvendor),
      callback: function($$v) {
        _vm.adhocvendor = $$v
      },
      expression: "adhocvendor"
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketvendorname),
      expression: "marketvendorname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Vendor Name",
      "name": "MarketVendorName",
      "id": "MarketVendorName",
      "data-vv-scope": "localtripTab"
    },
    domProps: {
      "value": (_vm.marketvendorname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.marketvendorname = $event.target.value
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.triptypeitem.value == 'market' && !_vm.isAdhocEnable) || (!_vm.isBikerTripEnabled && (_vm.triptypeitem.value == 'local' && _vm.isVTRAFlag))) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.VehicleType')
    },
    attrs: {
      "options": _vm.vehicletypelist,
      "selected-option": _vm.vehicletypeitem,
      "name": "VehicleType",
      "placeholder": "Select Vehicle Type",
      "id": "VehicleType",
      "data-vv-scope": "localtripTab"
    },
    on: {
      "select": _vm.selectvehicletype
    },
    model: {
      value: (_vm.vehicletype),
      callback: function($$v) {
        _vm.vehicletype = $$v
      },
      expression: "vehicletype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.VehicleType')),
      expression: "errors.has('localtripTab.VehicleType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.VehicleType')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.vehicletypeloader))])], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.triptypeitem.value == 'market' || _vm.isBikerTripEnabled) && !_vm.isAdhocEnable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localvehicleno),
      expression: "localvehicleno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.VehicleNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle No",
      "name": "VehicleNo",
      "id": "VehicleNo",
      "data-vv-scope": "localtripTab",
      "title": "Use Space As Delimiter e.g. MH 01 AB 0123, DL 01L AB 1234, PB 01 1212, MHU 123, DL 1 GE 2236, DL 1L AH 4206, AB 123 A 1234, AB 12 ABC 1234",
      "pattern": "^([A-Z|a-z]{2}\\s{1}[0-9]{1,2}\\s{1}[A-Z|a-z]{1,3}\\s{1}\\d{4})?([A-Z|a-z]{2}\\s{1}[0-9]{1,2}[A-Z|a-z]{1}\\s{1}[A-Z|a-z]{2}\\s{1}\\d{4})?([A-Z|a-z]{3}\\s{1}\\d{3})?([A-Z|a-z]{2}\\s{1}[0-9]{2}\\s{1}\\d{4})?([A-Z|a-z]{2}\\s{1}[0-9]{1,3}\\s{1}[A-Z|a-z]{1}\\s{1}\\d{3,4})?$"
    },
    domProps: {
      "value": (_vm.localvehicleno)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.localvehicleno = $event.target.value
      }, function($event) {
        _vm.localvehicleno = _vm.localvehicleno.toUpperCase()
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.VehicleNo')),
      expression: "errors.has('localtripTab.VehicleNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.VehicleNo')))]), _vm._v(" "), (_vm.validVehicleNoError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Invalid VehicleNo, Use Space As Delimiter e.g.MH 01 AB 0123, DL 01L AB 1234, PB 01 1212, MHU 123, AB 123 A 1234, AB 12 ABC 1234")]) : _vm._e()], 1)], 1) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.VehicleNo')
    },
    attrs: {
      "options": _vm.localvehiclenolist,
      "selected-option": _vm.localvehiclenoitem,
      "name": "VehicleNo",
      "placeholder": "Select VehicleNo",
      "id": "VehicleNo",
      "data-vv-scope": "localtripTab"
    },
    on: {
      "select": _vm.selectVehicleNo
    },
    model: {
      value: (_vm.localvehicleno),
      callback: function($$v) {
        _vm.localvehicleno = $$v
      },
      expression: "localvehicleno"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.VehicleError))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.VehicleNo')),
      expression: "errors.has('localtripTab.VehicleNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.VehicleNo')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.LocalVehicleNoLoading))])], 1)], 1), _vm._v(" "), (!_vm.isBikerTripEnabled && _vm.triptypeitem.value == 'market' && _vm.isAdhocEnable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.VehicleType')
    },
    attrs: {
      "options": _vm.vehicletypelist,
      "selected-option": _vm.vehicletypeitem,
      "name": "VehicleType",
      "placeholder": "Select Vehicle Type",
      "id": "VehicleType",
      "data-vv-scope": "localtripTab"
    },
    model: {
      value: (_vm.vehicletype),
      callback: function($$v) {
        _vm.vehicletype = $$v
      },
      expression: "vehicletype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.VehicleType')),
      expression: "errors.has('localtripTab.VehicleType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.VehicleType')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.vehicletypeloader))])], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.triptypeitem.value == 'local' && _vm.isVTRAFlag)) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Cut Off")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-clock-o'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.Cutoff')
    },
    attrs: {
      "options": _vm.cutofflist,
      "selected-option": _vm.cutoffitem,
      "name": "Cutoff",
      "placeholder": "Select Cutoff",
      "data-vv-scope": "localtripTab"
    },
    on: {
      "select": _vm.selectedCutoff
    },
    model: {
      value: (_vm.cutoff),
      callback: function($$v) {
        _vm.cutoff = $$v
      },
      expression: "cutoff"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.CutoffError))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.Cutoff')),
      expression: "errors.has('localtripTab.Cutoff')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.Cutoff')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Open KM")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openkm),
      expression: "openkm"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.OpenKM')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "name": "OpenKM",
      "id": "OpenKM",
      "data-vv-scope": "localtripTab"
    },
    domProps: {
      "value": (_vm.openkm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openkm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.OpenKM')),
      expression: "errors.has('localtripTab.OpenKM')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.OpenKM')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.triptypeitem.value == 'market' || (!_vm.isBikerTripEnabled && _vm.triptypeitem.value != 'local')),
      expression: "triptypeitem.value=='market'||(!isBikerTripEnabled && triptypeitem.value!='local')"
    }],
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Reason for Market Hire")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.Reason')
    },
    attrs: {
      "options": _vm.reasonlist,
      "selected-option": _vm.reasonitem,
      "name": "Reason",
      "placeholder": "Select Reason",
      "id": "Reason",
      "data-vv-scope": "localtripTab"
    },
    on: {
      "select": _vm.selectReason
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.Reason')),
      expression: "errors.has('localtripTab.Reason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.Reason')))])], 1)], 1), _vm._v(" "), (!_vm.isBikerTripEnabled) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.Amount')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Amount",
      "name": "Amount",
      "id": "Amount",
      "data-vv-scope": "localtripTab"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.Amount')),
      expression: "errors.has('localtripTab.Amount')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.Amount')))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isBikerTripEnabled) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Driver Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.drivername),
      expression: "drivername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.DriverName')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Driver Name",
      "name": "DriverName",
      "id": "DriverName",
      "data-vv-scope": "localtripTab"
    },
    domProps: {
      "value": (_vm.drivername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.drivername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.DriverName')),
      expression: "errors.has('localtripTab.DriverName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.DriverName')))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isBikerTripEnabled) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Driver Contact No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.drivercontactno),
      expression: "drivercontactno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|length:10'),
      expression: "'required|numeric|length:10'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.DriverContactNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Driver Contact No",
      "name": "DriverContactNo",
      "id": "DriverContactNo",
      "data-vv-scope": "localtripTab",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.drivercontactno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.drivercontactno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.DriverContactNo')),
      expression: "errors.has('localtripTab.DriverContactNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.DriverContactNo')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.triptypeitem.value == 'market' || !_vm.isVTRAFlag) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Cut Off")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-clock-o'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('localtripTab.Cutoff')
    },
    attrs: {
      "options": _vm.cutofflist,
      "selected-option": _vm.cutoffitem,
      "name": "Cutoff",
      "placeholder": "Select Cutoff",
      "data-vv-scope": "localtripTab"
    },
    on: {
      "select": _vm.selectedCutoff
    },
    model: {
      value: (_vm.cutoff),
      callback: function($$v) {
        _vm.cutoff = $$v
      },
      expression: "cutoff"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.CutoffError))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('localtripTab.Cutoff')),
      expression: "errors.has('localtripTab.Cutoff')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('localtripTab.Cutoff')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "4%"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ResetLocalTripDetails
    }
  }, [_vm._v("Cancel")])])])], 1), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.trip == 'linehaulbiker'),
      expression: "trip=='linehaulbiker'"
    }],
    attrs: {
      "name": "bikertripTab"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitLinehaulBikerTrip('bikertripTab')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Trip Sheet No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripsheetno),
      expression: "tripsheetno"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('bikertripTab.TripSheetNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Trip Sheet No",
      "name": "TripSheetNo",
      "id": "TripSheetNo",
      "data-vv-scope": "bikertripTab"
    },
    domProps: {
      "value": (_vm.tripsheetno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripsheetno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bikertripTab.TripSheetNo')),
      expression: "errors.has('bikertripTab.TripSheetNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bikertripTab.TripSheetNo')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("TripSheet No Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    class: {
      'error': _vm.errors.has('bikertripTab.TripSheetNoDate')
    },
    attrs: {
      "disabled": "",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "TripSheetNoDate",
      "data-vv-scope": "bikertripTab"
    },
    model: {
      value: (_vm.tripsheetnodate),
      callback: function($$v) {
        _vm.tripsheetnodate = $$v
      },
      expression: "tripsheetnodate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bikertripTab.TripSheetNoDate')),
      expression: "errors.has('bikertripTab.TripSheetNoDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bikertripTab.TripSheetNoDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('bikertripTab.Route')
    },
    attrs: {
      "options": _vm.routelist,
      "selected-option": _vm.routeitem,
      "name": "Route",
      "placeholder": "Select Route",
      "id": "Route",
      "data-vv-scope": "bikertripTab"
    },
    on: {
      "select": _vm.selectRoute
    },
    model: {
      value: (_vm.route),
      callback: function($$v) {
        _vm.route = $$v
      },
      expression: "route"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.RouteError))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bikertripTab.Route')),
      expression: "errors.has('bikertripTab.Route')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bikertripTab.Route')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.RouteLoading))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#1985ac",
      "font-weight": "bold",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.actualroute))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('bikertripTab.BikerVehicleNumber')
    },
    attrs: {
      "options": _vm.bikervehiclelist,
      "selected-option": _vm.bikervehicleitem,
      "name": "BikerVehicleNumber",
      "placeholder": "Select Vehicle No",
      "id": "BikerVehicleNumber",
      "data-vv-scope": "bikertripTab"
    },
    on: {
      "select": _vm.selectBikerVehicleNumber
    },
    model: {
      value: (_vm.bikervehiclenumber),
      callback: function($$v) {
        _vm.bikervehiclenumber = $$v
      },
      expression: "bikervehiclenumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bikertripTab.BikerVehicleNumber')),
      expression: "errors.has('bikertripTab.BikerVehicleNumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bikertripTab.BikerVehicleNumber')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.BikerVehicleNumberLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Biker Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('bikertripTab.BikerName')
    },
    attrs: {
      "options": _vm.bikerlist,
      "selected-option": _vm.bikeritem,
      "name": "BikerName",
      "placeholder": "Select Biker",
      "id": "BikerName",
      "data-vv-scope": "bikertripTab"
    },
    on: {
      "select": _vm.selectBikerName
    },
    model: {
      value: (_vm.bikername),
      callback: function($$v) {
        _vm.bikername = $$v
      },
      expression: "bikername"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bikertripTab.BikerName')),
      expression: "errors.has('bikertripTab.BikerName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bikertripTab.BikerName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.BikerNameLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Open KM")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openkm),
      expression: "openkm"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('bikertripTab.OpenKM')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "name": "OpenKM",
      "id": "OpenKM",
      "data-vv-scope": "bikertripTab"
    },
    domProps: {
      "value": (_vm.openkm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openkm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bikertripTab.OpenKM')),
      expression: "errors.has('bikertripTab.OpenKM')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bikertripTab.OpenKM')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "4%"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ResetBikerTripDetails
    }
  }, [_vm._v("Cancel")])])])], 1)])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd44679","hasScoped":true}!./src/views/components/NetworkManagement/UnScheduledList/UnScheduledList.html
// module id = 959
// module chunks = 2